var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,12.2c-0.3,0.5-0.6,0.9-1,1.3c-1.5,1.8-3.3,3.3-5.3,4.5c-1.5,0.9-3.2,1.5-4.9,1.6c-1.5,0.1-3-0.1-4.4-0.6 c-1.9-0.7-3.5-1.8-5.1-3.1c-1.1-0.9-2.1-2-3-3.1c-0.5-0.6-0.5-0.9,0-1.5C2,9.2,4,7.4,6.3,6c1.5-0.9,3.2-1.5,5-1.7 c1.5-0.1,3,0.1,4.4,0.7c1.9,0.7,3.5,1.8,5.1,3.1c1.1,0.9,2.1,2,3,3.1c0.1,0.2,0.2,0.3,0.3,0.5C24,11.9,24,12.1,24,12.2z M12.1,18 c0.2,0,0.6,0,0.9-0.1c1.5-0.2,2.8-0.8,4.1-1.5c1.9-1.1,3.5-2.6,4.9-4.3c0.1-0.1,0.1-0.2,0-0.3c-0.8-1-1.7-1.9-2.7-2.7 c-1.3-1.1-2.7-2-4.2-2.6C13.8,6.1,12.4,5.8,11,6C9.5,6.2,8.2,6.8,6.9,7.6C5,8.7,3.4,10.2,2,11.9C1.9,12,1.9,12,2,12.2 c0.4,0.4,0.7,0.8,1.1,1.2c1.3,1.3,2.6,2.4,4.2,3.3C8.8,17.5,10.3,18,12.1,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,12c-0.1,2.7-2.2,4.8-4.8,4.8c-2.7,0-4.8-2.2-4.8-4.8c0-2.7,2.2-4.8,4.8-4.8C14.8,7.2,16.8,9.4,16.8,12z  M15.1,12c0-1.7-1.4-3.1-3.1-3.1c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1C13.7,15.1,15.1,13.7,15.1,12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.a31342868a094d43492624e24de7d82f.svg";
export { ForwardRef as ReactComponent };